import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { SignerService } from '@app/core/services/signer/signer.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'app works!';
  brand = environment.brand;

  @HostListener('wheel', ['$event'])
  onWheel(event: KeyboardEvent) {
    if (event.ctrlKey) {
      event.preventDefault();
      return false;
    }
  }
  @HostListener('touchmove', ['$event'])
  resizeMobile(event) {
    if (event.scale && event.scale !== 1) {
      event.preventDefault();
    }
  }

  public constructor(
    private titleService: Title,
    translate: TranslateService,
    private signerService: SignerService,
    private renderer: Renderer2,
  ) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('en');
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  ngOnInit() {
    this.setTitle(environment.brandTitle);
    const signerInfo = this.signerService.get();

    if (this.brand) {
      this.renderer.addClass(document.body, this.brand);
    }

    if (!signerInfo) {
      return;
    }

    if (signerInfo.clientId) {
      this.renderer.setAttribute(document.body, 'client', this.brand);
    } else {
      this.renderer.removeAttribute(document.body, 'client');
    }
  }
}
